'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcIsolateScope
* @element ANY
* @description
* # tcIsolateForm
* Removes the nested form from the parent
*/
angular.module('tcApp')
.directive('tcIsolateForm', function() {
	return {
		restrict: 'A',
		require: '?form',
		link: function(scope, element, attrs, formController) {
			if (!formController) {
        return;
      }

      var parentForm = formController.$$parentForm; // eslint-disable-line
      if (!parentForm) {
        return;
      }

      // Remove this form from parent controller
      parentForm.$removeControl(formController);
		}
	};
});
